// Global Selectors
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
} from 'workspaces/react-router-selectors';

// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import orderBy from 'utils/custom-orderBy';

// Local Selectors
import { selectFilteredData } from '../EventsTimeline/selectors';

const selectRelevantData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState =>
        filteredDataState.filter(
            ({ quantitySchedules }) =>
                !quantitySchedules || !quantitySchedules.length
        )
);

const selectDataLength = createDeepEqualSelector(
    selectRelevantData,
    relevantDataState => relevantDataState.length
);

const selectOrderedData = createDeepEqualSelector(
    [selectRelevantData, makeSelectQueryStringValue('sort')],
    (relevantDataState, sortState = 'entity.pathNames_ascending') => {
        const attributes = sortState.split('_');
        const propertyName = attributes[0];
        const order = attributes[1] !== 'descending' ? 'asc' : 'desc';
        return orderBy(relevantDataState, propertyName, order);
    }
);

const selectPaginatedData = createDeepEqualSelector(
    [
        selectOrderedData,
        makeSelectQueryStringNumberValue('page'),
        makeSelectQueryStringNumberValue('count')
    ],
    (orderedDataState, pageState = 1, countState = 5) => {
        const begin = (pageState - 1) * countState;
        const end = pageState * countState;
        return orderedDataState.slice(begin, end);
    }
);

const selectUuids = createDeepEqualSelector(
    selectPaginatedData,
    paginatedDataState =>
        paginatedDataState && paginatedDataState.map(value => value.uuid)
);

export { selectDataLength, selectOrderedData, selectUuids };
